import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';

/**
 * Popup de confirmation
 * @param {*} props 
 */
export default function Confirm(props) {
  const [open, setOpen] = useState(false);
  const [callback, setCallback] = useState();
  const { t } = useTranslation('common');

  const show = callback => event => {
    event.preventDefault()
    event = {
      ...event,
      target: { ...event.target, value: event.target.value }
    
    }
    setOpen(!props.validate || props.validate());
    setCallback([() => callback(event)])
  }

  const hide = () => {
    setOpen(false)
    setCallback()
  }

  const confirm = () => {
    callback[0]()
    hide()
  }

  return (
    <>
      {props.children(show)}
      {open && (
        <div className={open ? 'overlay open' : 'overlay'}>
          <div className="popup">
            <CloseIcon onClick={hide} className="close" />
            <h1>{props.title}</h1>
            <p>{props.description}</p>
            <div className="actions">
              <span className="cancel" onClick={hide}>{t('POP001')}</span>
              <span id={props.id ? props.id : 'confirm'} className="confirm" onClick={confirm}>{t('POP002')}</span>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
